// extracted by mini-css-extract-plugin
module.exports = {"confirm":"Confirm_confirm__2En-x","inline-buttons":"Confirm_inline-buttons__14n4O","message":"Confirm_message__3h3CE"};